import {
    MILLISECOND_MULTIPLIER,
    ROOM_RELOAD_SECONDS,
} from "../../roomList"

export const PREMIUM_REFRESH_SECONDS = 15
export const INACTIVE_THRESHOLD_MILLISECONDS = 60000
export const SPA_RELOAD_MILLISECONDS = ROOM_RELOAD_SECONDS * MILLISECOND_MULTIPLIER
export const SECONDARY_PAGE_PARAM = "pageb"  // URL param for secondary roomlist pagination on private cams page
